import { render, staticRenderFns } from "./videoview.vue?vue&type=template&id=64f48f18&scoped=true&"
import script from "./videoview.vue?vue&type=script&lang=js&"
export * from "./videoview.vue?vue&type=script&lang=js&"
import style0 from "./videoview.vue?vue&type=style&index=0&id=64f48f18&prod&scoped=true&lang=css&"
import style1 from "./videoview.vue?vue&type=style&index=1&id=64f48f18&prod&scoped=true&lang=css&"
import style2 from "./videoview.vue?vue&type=style&index=2&id=64f48f18&prod&scoped=true&lang=css&"
import style3 from "./videoview.vue?vue&type=style&index=3&id=64f48f18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f48f18",
  null
  
)

export default component.exports